import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=b21ce318&scoped=true&"
import script from "./StepIndicator.vue?vue&type=script&lang=js&"
export * from "./StepIndicator.vue?vue&type=script&lang=js&"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=b21ce318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21ce318",
  null
  
)

export default component.exports